module.exports = __webpack_public_path__ + "img/banner1.b30a3811.jpg";